import React from 'react';
import PropTypes from 'prop-types';

import { Box } from '@mui/material';

import EmployeePhoneLink from './EmployeePhoneLink';
import GpsStatus from './GpsStatus';
import RosterBadges from './RosterBadges';

const RosterMetaRow = ({
  isPriorityResourcePool,
  firstTimeWorkingThisCustomer,
  gpsStatus,
  showTime = false,
  compactBadges = false,
  card = false,
  employeePhoneNumber,
}) => {
  const showBadges = isPriorityResourcePool || firstTimeWorkingThisCustomer === true;
  const showPhone = typeof employeePhoneNumber === 'string' && employeePhoneNumber.length > 0;
  if (!showBadges && !gpsStatus && !showPhone) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        flexWrap: 'wrap',
        marginTop: '4px',
      }}
    >
      <RosterBadges
        isPriorityResourcePool={isPriorityResourcePool}
        firstTimeWorkingThisCustomer={firstTimeWorkingThisCustomer}
        compact={compactBadges}
        card={card}
        sx={{ marginTop: 0 }}
      />
      {gpsStatus && (
        <GpsStatus
          onsite={gpsStatus.onsite}
          timestamp={gpsStatus.timestamp}
          showTime={showTime}
          card={card}
        />
      )}
      <EmployeePhoneLink phoneNumber={employeePhoneNumber} />
    </Box>
  );
};

RosterMetaRow.propTypes = {
  isPriorityResourcePool: PropTypes.bool,
  firstTimeWorkingThisCustomer: PropTypes.bool,
  gpsStatus: PropTypes.shape({
    onsite: PropTypes.bool,
    timestamp: PropTypes.number,
  }),
  showTime: PropTypes.bool,
  compactBadges: PropTypes.bool,
  card: PropTypes.bool,
  employeePhoneNumber: PropTypes.string,
};

export default RosterMetaRow;
